// an apiClient wrapper for endpoints that require both authentication and tenant selection

export function createTenantApi(apiClient) {
  return function tenantApi(path, options = {}) {
    return apiClient(path, {
      headers: {}, // extract headers if given. otherwise use empty object
      query: {}, // extract query params if given. otherwise use empty object
      // method: "GET", // default to GET method if not set
      ...options, // spread other options
      requireAuth: true, // explicitly set to true (override any given option)
      requireTenant: true, // explicitly set to true (override any given option)
    });
  };
}